import React, {useEffect, useState} from "react";

import {useDispatch} from 'react-redux'

import {Route, Routes} from "react-router-dom";

import c from "./etc/Const"

import App from "../App"
import Handregler from "./handregler/handregler";
import Scenario from "./plan/Scenario";

import {fetchBidib, updateBidib, fetchPlan, updatePlan} from "../data/actions";

import {HTML5Backend} from "react-dnd-html5-backend";
import {DndProvider} from "react-dnd";
import Modulview from "./plan/modulview";
import Programmer from "./programmer/Programmer";


export default function BidibDataProvider({}) {
    const wsUrl = "ws://" + window.location.hostname + ":" + c.PORT + "/ws"

    const [webSocketReady, setWebSocketReady] = useState(false);
    const [webSocket, setWebSocket] = useState(new WebSocket(wsUrl));
    const [data, setData] = useState({});
    const [log, setLog] = useState([]);

    //const bidib = useSelector(state => state.bidib.value)
    const dispatch = useDispatch()

    function setDone(uid) {
        const index = log.findIndex(item => item.uid === uid);
        if (index > -1) {
            log.splice(index, 1);
            setLog([...log]) // spread to force rerender
        }
    }

    function logmessage(lm) {
        log.push(lm)
        setLog([...log]); // spread to force rerender
    }

    let sc = <Scenario/>

    function tryParseJSONObject(jsonString) {
        try {
            var o = JSON.parse(jsonString);
            if (o && typeof o === "object") {
                return o;
            }
        } catch (e) {
        }

        return false;
    }

    function onWsData(json) {

        //const intervalId = setInterval(doFetch("bidib"), 1000);

        const jsons = tryParseJSONObject(json)
        if (jsons) {
            //console.log(jsons)

            if (jsons.type === "log") {
                logmessage(jsons)
            }

            if (jsons.type === "fetch") {
                console.log("ws data bidib:", json);
                //doFetch("bidib")
            }

            if (
                jsons.record || jsons.connection || jsons.node || jsons['client'] ||
                jsons.type === "node" || jsons.type === "connection" || jsons.type === "record" || jsons.type === "client" || jsons.type === "app"
            ) {

                //console.log("ws data bidib:", json)

                //if( jsons.type === "node")
                //    console.log("ws data bidib:", json)


                dispatch(updateBidib(jsons))

            } else if (jsons.typename === "item"
                || jsons.typename === "module"
                || jsons.typename === "scenario"
                || jsons.type === "lc"
            ) {

                dispatch(updatePlan(jsons))
            } else if( jsons.type ) {


            }
        } else {
            console.error("JSON PARSE FAILED: %s", json)
        }

    }

    /*
    useEffect(() => {
        //doFetch("bidib");
        //dispatch(fetchBidib())
        //ispatch(fetchPlan())
    }, [setData]);
    */

    useEffect(() => {
        webSocket.onopen = (event) => {
            setWebSocketReady(true);
            dispatch(fetchBidib())
            dispatch(fetchPlan())
        };

        webSocket.onmessage = function (event) {
            onWsData(event.data);
        };

        webSocket.onclose = function (event) {
            setWebSocketReady(false);
            setTimeout(() => {
                setWebSocket(new WebSocket(wsUrl));
            }, 1000);
        };

        webSocket.onerror = function (err) {
            setWebSocketReady(false);
            webSocket.close();
        };

    });

    return (
        <DndProvider backend={HTML5Backend}>

            <Routes>
                <Route exact path="/"
                       element={<App connected={webSocketReady} data={data} log={log} setDone={setDone}/>}/>

                <Route path="/l/:lcid" element={<Handregler/>}/>

                <Route path="/s/:scid" element={<Scenario/>}/>

                <Route path="/m/:modulid" element={<Modulview/>}/>

                <Route path="/prog/" element={<Programmer/>}/>

            </Routes>
        </DndProvider>
    )
}

export function sendToServer(value) {
    fetch('http://' + window.location.hostname + ":" + c.PORT + "/rest/bidib", {
        method: 'POST',
        body: JSON.stringify(value)
    }).then(function (response) {

    });
}
